export default __webpack_public_path__ + "static/media/26.36455f10.png";